/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DefaultEmailTemplateResponse {
    getFixupPrototypeFunction() { return DefaultEmailTemplateResponse.fixupPrototype; }

    static newInstance(model: Partial<DefaultEmailTemplateResponse>): DefaultEmailTemplateResponse {
        let obj = Object.assign(new DefaultEmailTemplateResponse(), model);
        DefaultEmailTemplateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DefaultEmailTemplateResponse>): DefaultEmailTemplateResponse {
        if (!model) return null;
        return DefaultEmailTemplateResponse.newInstance(<DefaultEmailTemplateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DefaultEmailTemplateResponse) {
        if (!obj) return;

        models.DefaultEmailTemplateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DefaultEmailTemplateResponse): boolean {
        Object.setPrototypeOf(obj, DefaultEmailTemplateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Email Template HTML content
     */
    email_template: string;

}
